export enum ScanStatusEnum {
  pending = 'Pendiente',
  notProcessed = 'No Procesado',
  processed = 'Procesado',
  rejected = 'Rechazado',
  error = 'Fallido',
  incomplete = 'Faltan datos',
  duplicated = 'Duplicado',
}

export function isScanProcessing(status: ScanStatusEnum): boolean {
  return [ScanStatusEnum.pending, ScanStatusEnum.notProcessed].includes(status);
}
